import React from "react"
import { FormattedMessage } from "react-intl"
import PropTypes from "prop-types"
import { Modal, Button } from "react-bootstrap"
	
const ArchiveModel = ({ isShown, handleClose, title , HandleArchive ,isDeleting , isArchive , isUnarchive }) => (
	<Modal show={isShown} onHide={handleClose} centered className="modal-delete">
		
		<Modal.Header closeButton>
			<Modal.Title>
			{isArchive ? isUnarchive ? <FormattedMessage id="labels.unarchive" /> :  <FormattedMessage id="labels.archive" /> : <FormattedMessage id="labels.delete" />}
			?
			</Modal.Title>
		</Modal.Header>
		<Modal.Body>
			<strong>{title} </strong> 
				{isArchive ? isUnarchive ?<FormattedMessage id="messages.will_be_Unarchived" /> : 
					<FormattedMessage id="messages.will_be_archived" />
					 :
					<FormattedMessage id="messages.will_be_deleted" />}!
				
		</Modal.Body>
		<Modal.Footer>

			{isUnarchive ? 
				<Button variant="danger" disabled={isDeleting} onClick={HandleArchive}>
					<FormattedMessage id="labels.unarchive" />
				</Button> :
				<Button variant="danger" disabled={isDeleting} onClick={HandleArchive}>
					<FormattedMessage id="labels.archive" />
				</Button>
			 }
			<Button variant="outline-secondary" onClick={handleClose}>
				<FormattedMessage id="labels.close" />
			</Button>
		</Modal.Footer>
	</Modal>
)

ArchiveModel.propTypes = {
	isShown: PropTypes.bool.isRequired,
	isDeleting: PropTypes.bool.isRequired,
	handleClose:PropTypes.func.isRequired,
	handleDelete:PropTypes.func.isRequired,
	title: PropTypes.string.isRequired
}
export default ArchiveModel
